import { renderCart } from './cart.js';
import { updateCatalogCardStatus, saveCatalogCard } from './catalog-card.js';

const getOrderList = () => {
  const data = JSON.parse(localStorage.getItem('serviceCatalogCart'));

  const total = data.reduce((sum, item) => sum + parseInt(item.price), 0);

  const result = data
  .map(item => `${item.title} (ID: ${item.id}) - ${parseInt(item.price).toLocaleString('ru-RU')} руб.`)
  .join('\n') 
  + '\n' + '-'.repeat(50) 
  + `\nИтого: ${total.toLocaleString('ru-RU')} руб.`;

  console.log(result);
  return result;
}

const orderForm = document.querySelector('.order-form');

const showThanks = () => {
  document.querySelector('.order-modal').classList.add('is-active');
  document.querySelector('.order-modal--main').classList.remove('is-active');
  document.querySelector('.order-modal--thanks').classList.add('active');

  document.querySelector('.close-thanks').addEventListener('click', () => {
    document.querySelector('.order-modal').classList.remove('is-active');
    document.querySelector('.order-modal--thanks').classList.remove('active');
  });

  // Закрытие по клику вне модалки
  document.querySelector('.order-modal').addEventListener('click', (e) => {
    if(e.target.classList.contains('order-modal')) {
      document.querySelector('.order-modal--thanks').classList.remove('active');
      document.querySelector('.order-modal--main').classList.remove('blur');
    }
  });
}

async function sendLead(finalData) {
  try {
    const response = await fetch('https://sellerden.ru/leadsmanager/api/v1/limited/leads', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(finalData),
    });

    if (response.ok) {
      console.log('Сообщение отправлено!');
      orderForm.reset();
      showThanks();
      localStorage.removeItem('serviceCatalogCart');
      const emptyСart = [];
      renderCart(emptyСart);
      updateCatalogCardStatus(emptyСart);
      saveCatalogCard(emptyСart);
      document.querySelector('.cart__total-price').innerHTML = '';
      
    } else {
      console.error('Failed to send lead');
      alert('Ошибка при отправке формы. Попробуйте снова.');
    }
  } catch (error) {
    console.error('Error sending lead:', error);
    alert('Произошла ошибка. Попробуйте снова.');
  }
}

function getCookie(name) {
  const cookieString = document.cookie;
  const cookies = cookieString.split('; ');

  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}

const sendOrderForm = () => {
  orderForm.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    const nameField = orderForm.querySelector('[name="name"]');
    const telField = orderForm.querySelector('[name="tel"]');

    const { href } = window.location;
    const url = new URL(href);

    const referrer = getCookie('referrer');

    const finalData = {
      name: nameField.value.trim(),
      tel: telField.value.trim(),
      comment: getOrderList(),
      referer_url: referrer,
      landing_url: url.origin,
      branch_url: url.href,
    };

    sendLead(finalData);
    console.log(finalData);
  })
}

export {sendOrderForm}